import type CK from '~/types/contentking';

import {
	useAccountPaymentStatusQuery,
} from './useAccountPaymentStatus.gql';



function useAccountPaymentStatus(accountId: CK.AccountId | null) {
	const { data } = useAccountPaymentStatusQuery({
		skip: accountId === null,
		variables: {
			accountId: accountId ?? 0,
		},
	});

	return data?.account?.paymentStatus ?? null;
}



export default useAccountPaymentStatus;
